import React from 'react'
import { compose } from 'redux'
// import injectSheet from 'react-jss'
import { injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import { Dialog, Card, Box } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import { FacebookShareButton, LineShareButton, TelegramIcon, TelegramShareButton, WhatsappShareButton } from 'react-share'

import crossIcon from '../../../../assets/icons/socialMedia/cross.svg'
import facebookIcon from '../../../../assets/icons/socialMedia/facebook.svg'
// import instergramIcon from '../../../../assets/icons/socialMedia/instergram.svg'
import whatsappIcon from '../../../../assets/icons/socialMedia/whatsapp.svg'
import lineIcon from '../../../../assets/icons/socialMedia/line.svg'
// import wechatIcon from '../../../../assets/icons/socialMedia/wechat.svg'

import * as directoryActions from '../../../../actions/components/directory'

class Share extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
    }
  }

  toggleShareDialog = () => this.props.updateDisplayShareDialog(!this.props.directory.display.shareDialog)

  render () {
    const {
      classes,
      merchant,
      directory,
      updateDisplayShareDialog,
      updateDisplayNavbarMenu,
    } = this.props

    if (!merchant) return null

    const { shareDialog } = directory.display
    /* const {
      facebookLink,
      instagramLink,
      whatsappLink,
      lineLink,
      wechatLink,
    } = merchant.setting */
    const shareUrl = 'http://s.dimorder.com/Eu3kLm5ME'
    const message = '我啱啱喺 「點單-跨區外送美食指南」搵到心愛餐廳,你不如一齊睇下~'

    const handleClose = () => {
      updateDisplayShareDialog(false)
      updateDisplayNavbarMenu(false)
    }

    /* const handleClick = (link) => {
      window.open(link, '_blank')
      handleClose()
    } */

    return (
      <Dialog
        open={shareDialog}
        onClose={handleClose}
        fullWidth
        classes={{
          paper: classes.paperRoot,
          paperFullWidth: classes.paperFullWidth,
        }}
      >
        <Card className={classes.card}>
          <img src={crossIcon} alt='cross_icon' className={classes.closeButton} onClick={handleClose} />
          <Box display='flex' flexDirection='row' justifyContent='space-around'>
            {/* {facebookLink && <img src={facebookIcon} alt='facebook_icon' onClick={() => handleClick(facebookLink)} />}
            {instagramLink && <img src={instergramIcon} alt='instergram_icon' onClick={() => handleClick(instagramLink)} />}
            {whatsappLink && <img src={whatsappIcon} alt='whatsapp_icon' onClick={() => handleClick(whatsappLink)} />}
            {lineLink && <img src={lineIcon} alt='line_icon' onClick={() => handleClick(lineLink)} />}
            {wechatLink && <img src={wechatIcon} alt='wechat_icon' onClick={() => handleClick(wechatLink)} />} */}
            <FacebookShareButton url={shareUrl} quote={message} onClick={handleClose}>
              <img src={facebookIcon} alt='facebook_icon' />
            </FacebookShareButton>
            <WhatsappShareButton url={shareUrl} title={message} onClick={handleClose}>
              <img src={whatsappIcon} alt='whatsapp_icon' />
            </WhatsappShareButton>
            <LineShareButton url={shareUrl} title={message} onClick={handleClose}>
              <img src={lineIcon} alt='line_icon' />
            </LineShareButton>
            <TelegramShareButton url={shareUrl} title={message} onClick={handleClose}>
              <TelegramIcon size={30} round />
            </TelegramShareButton>
          </Box>
        </Card>
      </Dialog>
    )
  }
}

const styles = {
  paperFullWidth: {
    width: '100%',
    minWidth: '100%',
  },
  paperRoot: {
    position: 'fixed',
    top: 0,
    left: 0,
    margin: '40px 0px',
  },
  share: {
    position: 'fixed',
    top: 40,
    left: 0,
    height: 'calc(100vh - 40px)',
    width: '100vw',
    backgroundColor: '#00000066',
  },
  card: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#ffffff',
    borderRadius: 4,
    padding: '16px 24px',
  },
  closeButton: {
    position: 'absolute',
    top: 0,
    right: 0,
    padding: 8,
  },
  // gridContainer: {
  //   display: 'grid',
  //   gridTemplateColumns: 'repeat(5, 1fr)',
  //   gridGap: '4px',
  // },
}

const mapStateToProps = (state) => {
  return {
    merchant: state.merchant,
    directory: state.directory,
  }
}

const mapDispatchToProps = {
  updateDisplayShareDialog: directoryActions.updateDisplayShareDialog,
  updateDisplayNavbarMenu: directoryActions.updateDisplayNavbarMenu,
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles),
  injectIntl,
)(Share)



// WEBPACK FOOTER //
// ./src/components/scenes/DirectoryPage/Dialog/Share.jsx